import React, { useState, useMemo } from "react";
import { RxPlusCircled } from "react-icons/rx";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  CircularProgress,
  TextField,
  InputAdornment,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import useDebounce from "../../hooks/useDebounce";
import { useQuery } from "@tanstack/react-query";
import {
  getUserList,
  userActivation,
} from "../../../services/userManagementApi";
import UserList from "./UserList";
import ModalActivateUser from "../../common/particles.jsx/ModalActivateUser";
import ModalDeactivateUser from "../../common/particles.jsx/ModalDeactivateUser";
import { Search } from "@mui/icons-material";

const FETCH_LIMIT = 10;

const UserManagement = () => {
  const navigate = useNavigate();
  const [userEmail, setUserEmail] = useState("");
  const [search, setSearch] = useState("");
  const [offset, setOffset] = useState(1);
  const [openActivateUserModal, setOpenActivateUserModal] = useState(false);
  const [openDeactivateUserModal, setOpenDeactivateUserModal] = useState(false);

  const debounce = useDebounce(search, 500);

  const { data: users, isFetching } = useQuery({
    queryKey: ["users", debounce, offset],
    queryFn: () => getUserList(FETCH_LIMIT, offset, debounce),
    refetchOnWindowFocus: false,
  });

  const pageCount = useMemo(() => {
    if (users && users !== undefined)
      return Math.ceil(users.count / FETCH_LIMIT);
    return;
  }, [users]);

  return (
    <div className="">
      <ModalActivateUser
        openActivateUserModal={openActivateUserModal}
        setOpenActivateUserModal={setOpenActivateUserModal}
        userEmail={userEmail}
      />

      <ModalDeactivateUser
        openDeactivateUserModal={openDeactivateUserModal}
        setOpenDeactivateUserModal={setOpenDeactivateUserModal}
        userEmail={userEmail}
      />

      <div className="flex flex-wrap items-center gap-3 mt-3">
        <TextField
          fullWidth
          placeholder="Cari nama pengguna"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          }}
        />

        <button
          className={`w-full bg-[#007AF1] hover:bg-gray-200 w-full text-[14px] py-2 px-[20px] rounded-lg inline-flex text-center items-center justify-center gap-3`}
          onClick={() => navigate(`/user-management/create-user`)}
        >
          <span className={`text-white`}>
            <RxPlusCircled />
          </span>
          <span className={`text-white`}>Tambah Pengguna</span>
        </button>
      </div>
      {users && !isFetching && users !== undefined && users?.data !== null ? (
        <div>
          <TableContainer component={Paper} className="mt-3">
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="left">Nama & Akses Pengguna</TableCell>
                  <TableCell align="center">Status</TableCell>
                </TableRow>
              </TableHead>
              <>
                {users.data.map((item) => {
                  return (
                    <TableBody key={item.id}>
                      <TableRow
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="col" align="center">
                          <div className="flex flex-row gap-2 items-center">
                            <img
                              src={item.profile_photo}
                              alt=""
                              className="w-10 rounded-full"
                            />
                            <div className="flex flex-col">
                              <p className="text-start font-medium">
                                <Link
                                  to={`/user-management/detail-user/${item.id}/${item.company_id}`}
                                >
                                  {item.fullname}
                                </Link>
                              </p>
                              <p className="text-[10px] text-start">
                                {item.title_name}
                              </p>
                              <p className="text-[10px] text-start">
                                {item.company_name}
                              </p>
                            </div>
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <UserList
                            item={item}
                            statusCodeUser={item.status_code_user}
                            statusUser={item.status_user}
                            setUserEmail={setUserEmail}
                            setOpenDeactivateUserModal={
                              setOpenDeactivateUserModal
                            }
                            setOpenActivateUserModal={setOpenActivateUserModal}
                          />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  );
                })}
              </>
            </Table>
          </TableContainer>
          <div className="flex justify-center mt-[10px]">
            <Pagination
              count={pageCount}
              page={offset}
              onChange={(_, value) => setOffset(value)}
              shape="rounded"
              size="large"
              color="primary"
            />
          </div>
        </div>
      ) : isFetching ? (
        <div className="flex my-5 items-center justify-center">
          <CircularProgress size={20} />
        </div>
      ) : (
        <div className="my-5">
          <p className="text-center">Data Tidak ditemukan</p>
        </div>
      )}
    </div>
  );
};

export default UserManagement;
